module.exports = __webpack_public_path__ + "img/produkt-highligh_video-placeholder.bdec32cc.png";